<template>
  <div class="horizontal-lock">
    <div class="tabs" :class="{ container: $breakpoints.isGreaterThan('sm') }">
      <q-tabs inverted no-pane-border color="primary" v-model="selectedTab">
        <q-tab v-for="(tab, label, i) in computedTabs" :key="label"
               :default="i==0" slot="title" :label="$T(label)" :name="`tab-${label}`"/>
        <q-tab-pane v-for="(tab, label) in computedTabs" :key="label" :name="`tab-${label}`">
          <slot :name="`tab-${label}`">
            <v-row-group v-for="(group, model) in tab.rowGroups" :key="model"
                         :title="$T(model)" :rows="group" :is-video="isVideo"></v-row-group>
          </slot>
        </q-tab-pane>
      </q-tabs>
    </div>
  </div>
</template>

<script>
import {
  QTabs,
  QTab,
  QTabPane
} from 'quasar-framework'

export default {
  name: 'VTabs',

  components: {
    QTabs,
    QTab,
    QTabPane
  },
  props: {
    tabs: {
      type: [Array, Object],
      required: true
    },
    all: Boolean,
    isVideo: Boolean,
  },
  data: () => ({selectedTab: null}),
  watch: {
    '$route'() {
      if (Object.keys(this.tabs).length > 0)
        this.selectedTab = 'tab-' + Object.keys(this.tabs)[0]
    }
  },
  computed: {
    computedTabs() {
      if (!this.all)
        return this.tabs
      let allTabs = {
        all: {
          rowGroups: {}
        }
      }
      Object.keys(this.tabs).forEach((tab) => Object.assign(allTabs.all.rowGroups, this.tabs[tab].rowGroups ))
      return Object.assign(allTabs,this.tabs)
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Tabs.vue